import { Spinner } from '@/components/ui/spinner';

export function AppSplash() {
  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <Spinner size={32} className="text-primary" />
        <span className="text-sm text-muted-foreground font-medium animate-pulse">
          Loading ZAAG Social...
        </span>
      </div>
    </div>
  );
}
